import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { getAuth } from "@/lib/auth";

import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ClientDashboard from "@/pages/ClientDashboard";
import ClientDocUpload from "@/pages/ClientDocUpload";
import ClientTermSign from "@/pages/ClientTermSign";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminClients from "@/pages/AdminClients";
import AdminCases from "@/pages/AdminCases";
import AdminCaseDetail from "@/pages/AdminCaseDetail";
import AdminLists from "@/pages/AdminLists";
import AdminListDetail from "@/pages/AdminListDetail";
import AdminReturns from "@/pages/AdminReturns";
import AdminBulkDocs from "@/pages/AdminBulkDocs";
import AdminClientReport from "@/pages/AdminClientReport";
import AdminBaixasConcluidas from "@/pages/AdminBaixasConcluidas";
import AdminLoteDetail from "@/pages/AdminLoteDetail";
import AdminTrash from "@/pages/AdminTrash";
import AdminLayout from "@/components/AdminLayout";
import ClientLayout from "@/components/ClientLayout";
import AtendimentoLayout from "@/components/AtendimentoLayout";
import AtendimentoDashboard from "@/pages/atendimento/AtendimentoDashboard";
import AtendimentoInbox from "@/pages/atendimento/AtendimentoInbox";
import AtendimentoAgents from "@/pages/atendimento/AtendimentoAgents";
import AtendimentoQueues from "@/pages/atendimento/AtendimentoQueues";
import AtendimentoKnowledge from "@/pages/atendimento/AtendimentoKnowledge";
import AtendimentoTicket from "@/pages/atendimento/AtendimentoTicket";
import AtendimentoWhatsApp from "@/pages/atendimento/AtendimentoWhatsApp";
import AtendimentoWebchatConfig from "@/pages/atendimento/AtendimentoWebchatConfig";
import AtendimentoCommandCenter from "@/pages/atendimento/AtendimentoCommandCenter";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const auth = getAuth();
  if (!auth) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(auth.user.role)) {
    return <Navigate to={auth.user.role === 'admin' ? '/admin' : '/client'} replace />;
  }
  return children;
};

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          {/* Client Routes */}
          <Route path="/client" element={
            <ProtectedRoute allowedRoles={['client']}>
              <ClientLayout />
            </ProtectedRoute>
          }>
            <Route index element={<ClientDashboard />} />
            <Route path="documents/:caseId" element={<ClientDocUpload />} />
            <Route path="term/:caseId" element={<ClientTermSign />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="report" element={<AdminClientReport />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="cases" element={<AdminCases />} />
            <Route path="cases/:caseId" element={<AdminCaseDetail />} />
            <Route path="documents" element={<AdminBulkDocs />} />
            <Route path="lists" element={<AdminLists />} />
            <Route path="lists/:listId" element={<AdminListDetail />} />
            <Route path="returns" element={<AdminReturns />} />
            <Route path="returns/lote/:loteId" element={<AdminLoteDetail />} />
            <Route path="concluidas" element={<AdminBaixasConcluidas />} />
            <Route path="trash" element={<AdminTrash />} />
            <Route path="atendimento" element={<AtendimentoLayout />}>
              <Route index element={<AtendimentoDashboard />} />
              <Route path="inbox" element={<AtendimentoInbox />} />
              <Route path="ticket/:convId" element={<AtendimentoTicket />} />
              <Route path="agents" element={<AtendimentoAgents />} />
              <Route path="queues" element={<AtendimentoQueues />} />
              <Route path="knowledge" element={<AtendimentoKnowledge />} />
              <Route path="whatsapp" element={<AtendimentoWhatsApp />} />
              <Route path="webchat" element={<AtendimentoWebchatConfig />} />
              <Route path="command" element={<AtendimentoCommandCenter />} />
            </Route>
          </Route>
          
          {/* Default redirect */}
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

function RootRedirect() {
  const auth = getAuth();
  if (!auth) return <Navigate to="/login" replace />;
  return <Navigate to={auth.user.role === 'admin' ? '/admin' : '/client'} replace />;
}

export default App;
